module.exports = __webpack_public_path__ + "img/woo_logo.12ed6396.png";